import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
import bowser from 'bowser';
import inview from 'jquery-inview';
import remodal from 'remodal';
import matchHeight from 'jquery-match-height';
const FloatAnimation = require('./FloatAnimation');

if(bowser.msie === true) {
  $('body').addClass('ie');
}else if(bowser.msedge === true){
  $('body').addClass('edge');
}else if(bowser.firefox === true){
  $('body').addClass('ff');
}else if(bowser.tablet === true){
  $('body').addClass('tablet');
}
if(bowser.mobile === true){
  $('body').addClass('device--mobile');
  if(bowser.android === true) {
    $('body').addClass('device--mobile--android');
  }
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
  os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
  os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
  os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
  os = "win7";
}else{
  os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
// const totop = new ToTop('#totop',100,400);
// totop.exec();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
const ac = new Accordion($('.faq_wrap-title'));
ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });
//

(function($) {
$(function(){
	$('.cp_textarea iframe,.remodal iframe').wrap('<div class="iframe_wrapper"></div>');

	$('a:not(:has(img))').each(function(){
		if($(this).parents('.no_linkicon').length == 0){
			$(this).addClass('js--link_icon');
		}
	});
	$('.js--link_icon[href^=http]:not([href*="'+location.hostname+'"],[href$=pdf],[href$=xls],[href$=xlsx],[href$=xlsm],[href$=doc],[href$=docx],[href$=pptx],[href$=pptm],[href$=ppt])').addClass('js--link_icon-ext').attr({target:"_blank"});

	$('.room_info-left').each(function(index){
		$(this).attr('id','r'+(index + 1)).addClass('anchor');
	});
});
})(jQuery);

const mv = require('./mv');
mv();

const slide_thumbnail = require('./slide_thumbnail');
slide_thumbnail();

if($('#map').length > 0){
	const map = require('./map');
	map();
}

const instagram = require('./instagram');
instagram();

$('.js-inview--single').on('inview',function(event, isInView, visiblePartX, visiblePartY){
	if(!$(this).hasClass('animated')){
		let float_animation = new FloatAnimation($(this),'bottom');
		float_animation.animateOneObj();
		float_animation = null;
	}
});

$('.js-inview--stagger_wrapper').on('inview',function(event, isInView, visiblePartX, visiblePartY){
	if(!$(this).hasClass('animated')){
		let float_animation = new FloatAnimation($(this).find('.js-inview--stagger'),'bottom');
		float_animation.animateStagger($(this),0.2);
		float_animation = null;
	}
});

$('.js-exwindow').on('click',function(){
	let url = $(this).attr('href');
	window.open(url,'SNS SHARE',"width=400,height=400,top=50,left=100");
	return false;
});



// WEBPACK FOOTER //
// ./dev/js/scripts/main.js